/**
 * Data from the search params is taken from the url and removed.
 * It is a known security issue to leave tokens in the url and leads to a
 * url that is bad for UX eg bookmarking / readability.
 */
import { AppURLSearchParams } from '../../../../auth';

export function deleteUrlParams () {
    const updatedURL = new URL(window.location.href);

    updatedURL.searchParams.delete(AppURLSearchParams.password);
    updatedURL.searchParams.delete(AppURLSearchParams.username);
    updatedURL.searchParams.delete(AppURLSearchParams.env);
    updatedURL.searchParams.delete(AppURLSearchParams.token);
    updatedURL.searchParams.delete(AppURLSearchParams.jwtToken);
    updatedURL.searchParams.delete(AppURLSearchParams.essentialsRedirect);
    // Locale from url is currently not working for user profile service
    // described in https://mathletics.atlassian.net/browse/COY-6811.
    updatedURL.searchParams.delete(AppURLSearchParams.lang);
    updatedURL.searchParams.delete(AppURLSearchParams.locale);

    window.history.replaceState(null, '', updatedURL.toString());
}
